export const localStoragePrefix = 'FCC';
